import * as React from 'react';


function SubmitButton({children}: {children: React.ReactNode}): React.JSX.Element {
    return (
        <button type="submit">{children}</button>
    );
}


export default SubmitButton;
